/**
 * アコーディオン
 * ・クラス付与
 * └ .js-accordion-item アイテム
 * └ .js-accordion-content コンテンツ
 * └ .js-accordion-trigger トリガー
 * ・初期状態で開いておくには.is-openを付与
 */

// ドロワーメニューのサブメニューアコーディオン
// 要素の存在チェックを追加
if ($(".js-accordion-item").length > 0) {
  // すべてのアコーディオンアイテムを処理
  $(".js-accordion-item").each(function () {
    var $item = $(this);
    var $content = $item.children(".js-accordion-content");

    if (!$item.hasClass("is-open")) {
      $content.hide(); // is-openクラスがない場合は非表示
    }
  });
}

// トリガー要素の存在チェックを追加
if ($(".js-accordion-trigger").length > 0) {
  $(".js-accordion-trigger").on("click", function (e) {
    e.stopPropagation(); // 親要素へのイベント伝播を防止
    var $parentItem = $(this).closest(".js-accordion-item");
    var $content = $parentItem.children(".js-accordion-content");

    // 親要素とコンテンツの存在チェック
    if ($parentItem.length === 0 || $content.length === 0) {
      return; // 要素が存在しない場合は処理を終了
    }

    if ($parentItem.hasClass("is-open")) {
      $parentItem.removeClass("is-open");
      $content.slideUp(300);
    } else {
      $parentItem.addClass("is-open");
      $content.slideDown(300);
    }
  });
}
